import { List, Skeleton, Typography } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CommentJson,
  FilterComment,
  TypeList,
} from "features/comment/types/comment.type";
import CommentModel from "common/models/CommentModel";
import { ListItemLayout } from "antd/es/list";
import InfiniteScroll from "react-infinite-scroll-component";

import ResultErrors from "templates/ResultErrors";
import { isEntityError, isFetchError } from "common/utils/errorResultRTK";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { selectToken } from "features/auth/AuthSlice";
import useGetCommentListEndpoint from "Hooks/useGetCommentListEndpoint";
import FormFilter from "../commentFilter/FormFilter";
import {
  selectListComment,
  selectListReview,
} from "features/comment/CommentSlice";
import CommentItem from "../commentItem/CommentItem";
export interface DataType extends CommentJson {
  loading?: boolean;
}
type Props = {
  itemRender?: (item: any, index: number) => React.ReactNode;
  itemLayout?: ListItemLayout;
  styleWrapper?: React.CSSProperties;
  classWrapper?: string;
  labelLoadMore?: string;
  styleLabelLoadMore?: React.CSSProperties;
  heightOverFlow?: string | number | undefined;
  borderOverFlow?: boolean;
  // dataSource: any[];
  id?: string;
  item_type: string;
  item_id: string;
  hiddenScrollBar?: boolean;
  type_list: TypeList;
  parent_user?: string;
};

const CommentList = ({
  itemRender,
  itemLayout,
  styleWrapper,
  classWrapper,
  labelLoadMore = "Xem thêm",
  heightOverFlow,
  borderOverFlow = true,
  // dataSource,
  id,
  item_id,
  item_type,
  hiddenScrollBar = false,
  styleLabelLoadMore = {
    // height: 32,
  },
  type_list,
  parent_user,
}: Props) => {
  const listReview = useAppSelector(selectListReview);
  const listComment = useAppSelector(selectListComment);

  //
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [list, setList] = useState<DataType[]>([]);
  const [is_hasMore, setIs_hasMore] = useState(false);
  const titleRef = useRef<HTMLElement>(null);

  //
  const defaultFilters: FilterComment = useMemo(() => {
    return {
      ...CommentModel.getDefaultFilter(),
      item_id: item_id,
      item_type: item_type,
    };
  }, [item_id, item_type]);
  const [filters, setFilters] = useState<FilterComment>({
    ...CommentModel.getDefaultFilter(),
    parent_id: id ? Number(id) : undefined,
    item_id: item_id,
    item_type: item_type,
  });

  const {
    listData: { currentData, data: datas, error, isLoading, refetch },
  } = useGetCommentListEndpoint({ filters, typeList: type_list });

  const erorrFetch = useMemo(() => {
    if (isEntityError(error)) {
      return {
        status: error.status,
        errors: error.data.error,
      };
    } else if (isFetchError(error)) {
      return {
        status: error.status,
        errors: [error.error],
      };
    }
  }, [error]);
  //
  const handleScroll = () => {
    if (titleRef.current) {
      titleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  };
  // handle load more data

  const onLoadMore = () => {
    setLoading(true);
    if (datas) {
      setFilters((prev) => {
        return {
          ...prev,
          limit: prev.limit + 5,
        };
      });
    }

    return new Promise(async (resole, reject) => {
      setList(data.concat([...new Array(5)].map(() => ({ loading: true }))));
      window.dispatchEvent(new Event("resize"));
      setLoading(false);
      resole(1);
    });
  };
  // button load more
  const loadMore = useMemo(() => {
    if (!datas || datas.total <= 5) {
      return null;
    } else {
      if (list.length < datas.total) {
        return (
          <div style={styleLabelLoadMore} className="label_loadmore">
            <Typography.Link underline={false} onClick={onLoadMore}>
              {labelLoadMore}
            </Typography.Link>
          </div>
        );
      } else {
        return (
          <div style={styleLabelLoadMore} className="label_loadmore">
            <Typography.Link
              underline={false}
              onClick={() => {
                handleScroll();
                setFilters((prev) => {
                  return {
                    ...prev,
                    limit: 5,
                  };
                });
              }}
            >
              Thu gọn
            </Typography.Link>
          </div>
        );
      }
    }
  }, [data, list]);

  const hasMore = useMemo(() => {
    if (datas) {
      if (list.length < datas.total) {
        return true;
      } else {
        return false;
      }
    }
  }, [datas, list]);

  const listchildComment = useMemo(() => {
    if (id) {
      return listComment.filter((i) => i.parent_id === Number(id));
    } else {
      return [];
    }
  }, [listComment]);
  //
  useEffect(() => {
    if (datas) {
      if (list.length < datas.total) {
        setIs_hasMore(true);
      } else {
        setIs_hasMore(false);
      }
      // if (token === null) {
      //   type_list === "review" &&
      //     setList((prev) => [...listReview].concat(datas.items));
      //   type_list === "comment" &&
      //     setList((prev) => [...listComment].concat(datas.items));
      // } else {
      //   if (type_list === "review") {
      //     setList((prev) => [...listReview].concat(datas.items));
      //     setData((prev) => [...listReview].concat(datas.items));
      //   } else if (type_list === "comment") {
      //     setList((prev) => [...listComment].concat(datas.items));
      //     setData((prev) => [...listComment].concat(datas.items));
      //   }
      // }
      if (type_list === "review") {
        setList((prev) => [...listReview].concat(datas.items));
        setData((prev) => [...listReview].concat(datas.items));
      } else if (type_list === "comment") {
        setList((prev) => [...listchildComment].concat(datas.items));
        setData((prev) => [...listchildComment].concat(datas.items));
      }
    } else {
      // setList([]);
      // setData([]);
    }
  }, [datas, listReview, listComment]);

  // useEffect(() => {
  //   if (listReview.length > 0) {
  //     setList(listReview);
  //   }
  // }, [listReview]);

  return (
    <div
      style={{
        ...styleWrapper,
        height: list.length > 0 ? heightOverFlow : "auto",
        border: borderOverFlow ? "1px solid rgba(140, 140, 140, 0.35)" : "",
      }}
      id={`${
        hiddenScrollBar ? "webkit-scroll-hide" : "webkit-scroll "
      } comment_item_wrapper`}
      className={classWrapper}
    >
      <span style={{ visibility: "hidden" }} ref={titleRef}></span>
      {error ? (
        <ResultErrors
          error={erorrFetch?.errors}
          prefixError="comment:errors"
          // status={erorrFetch?.status}
          statusCode={erorrFetch?.status}
          labelExtra="Tải lại !"
          handleExtra={() => {
            refetch();
          }}
        ></ResultErrors>
      ) : (
        <>
          {type_list === "review" && list && (
            <FormFilter
              filters={filters}
              setFilters={setFilters}
              defaultFilters={defaultFilters}
              is_image={true}
              is_time_type={true}
              className="form_filter_wrapper"
            ></FormFilter>
          )}
          {list.length > 0 && (
            <InfiniteScroll
              dataLength={list.length}
              next={() => {}}
              hasMore={true}
              loader={<Skeleton active loading={loading} />}
              // endMessage={
              //   type_list !== "comment" ? (
              //     <Divider plain>Đã hiển thị tất cả</Divider>
              //   ) : (
              //     <></>
              //   )
              // }
              scrollableTarget="scrollableDiv"
            >
              <List
                className={`demo-loadmore-list ${
                  type_list === "comment" ? "comment_loadmore_wrapper" : ""
                }`}
                loading={isLoading}
                itemLayout={itemLayout}
                loadMore={loadMore}
                dataSource={list}
                renderItem={(item: DataType, index: number) => (
                  <List.Item
                  // actions={[
                  //   <Skeleton title={true} loading={true} paragraph={true} active>
                  //     <a key="list-loadmore-edit">edit</a>
                  //   </Skeleton>,
                  //   <Skeleton title={true} loading={true} paragraph={true} active>
                  //     <a key="list-loadmore-more">more</a>
                  //   </Skeleton>,
                  // ]}
                  >
                    <Skeleton
                      title={true}
                      loading={item.loading ? item.loading : false}
                      paragraph={true}
                      active
                    >
                      {itemRender ? (
                        itemRender(item, index)
                      ) : (
                        <CommentItem
                          key={index}
                          data={item}
                          isLoading={false}
                          type_list={type_list}
                          item_id="comment"
                          item_type={item_type}
                          parent_user={
                            type_list !== "review" ? parent_user : undefined
                          }
                        ></CommentItem>
                      )}
                    </Skeleton>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          )}
        </>
      )}
    </div>
  );
};

export default CommentList;
